import CaseFolders from "../CaseFolders";
import Notifications from "../Notifications";
import Overview from "../Overview";
import PaymentHistory from "../PaymentHistory";
import Requests from "../Requests";
import Settings from "../Settings";

import ViewCaseFolder from "../case-folder/ViewCaseFolder";

export const Registrar1AssessmentRoute = [
  {
    title: "Overview",
    path: "/registrar1-assessment/overview",
    component: Overview,
  },
  {
    title: "Case Folders",
    path: "/registrar1-assessment/case-folders",
    component: CaseFolders,
  },

  {
    title: "View Case Folder",
    path: "/registrar1-assessment/case-folders/view",
    component: ViewCaseFolder,
  },

  {
    title: "Request",
    path: "/registrar1-assessment/request",
    component: Requests,
  },
  {
    title: "Payment history",
    path: "/registrar1-assessment/payment-history",
    component: PaymentHistory,
  },
  {
    title: "Notification",
    path: "/registrar1-assessment/notification",
    component: Notifications,
  },
  {
    title: "Setting",
    path: "/registrar1-assessment/setting",
    component: Settings,
  },
];
